import { Loader } from "@/components/loader/loader.component";

export const ConfiguratorAccessoriesLoader = () => {
  return (
    <section
      data-testid="configurator-accessories-loader"
      className="flex flex-1 items-center justify-center">
      <Loader loading size="lg" variant="secondary" />
    </section>
  );
};
